<template>
	<div class="Consent_Form">
		<div class="grid-x grid-margin-x">
			<div
				class="cell small-12 Consent_Form__border Consent_Form__border--top"
			></div>
			<div class="cell large-8">
				<label class="checkbox checkbox--lightTheme">
					<input
						class="checkbox__input"
						type="checkbox"
						name="marketingConsent"
						v-model="user.marketingConsent"
					/>
					<span class="checkbox__box">
						<span>
							<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
						</span>
					</span>
					<span
						class="Consent_Form__consent-text"
						v-html="$t('newaccount.marketingConsentTextShort')"
					></span>
				</label>
			</div>

			<div class="cell small-12">
				<p v-if="consentInfo != ''">
					<span
						:class="['consentInfo', { 'consentInfo--failed': !consentUpdated }]"
					>
						{{ consentInfo }}
					</span>
				</p>
			</div>

			<div class="cell large-12">
				<p
					class="Consent_Form__desc"
					v-html="$t('newaccount.consentDescription')"
				></p>
			</div>
		</div>
		<div class="grid-x grid-margin-x grid-margin-y">
			<div class="cell small-12">
				<div class="Consent_Form__button">
					<Button
						size="small"
						:loading="loading"
						@click.native="updateUserConsent"
					>
						{{ $t('edit.saveButton') }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../../vueX/store'

import Button from '../../atoms/Button'
//import InputComponent from '../../atoms/InputComponent'

export default {
	name: 'Consent_Form',
	data: () => {
		return {
			loading: false,
			consentInfo: '',
			consentUpdated: false,
			user: {}
		}
	},
	components: {
		Button
		//InputComponent
	},
	beforeMount() {
		// Deep clone user
		this.user = JSON.parse(JSON.stringify(this.storeUser))
	},
	methods: {
		updateUserConsent() {
			this.loading = true

			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
				if (response) {
					// console.log('update consent')
					// console.log(this.user)

					store
						.dispatch('PUT_USER', this.user)
						.then(success => {
							if (success) {
								this.loading = false
								this.consentUpdated = true
								this.consentInfo = this.$t('edit.consentUpdateSuccess')
								//this.$router.push({ name: 'profile' })
							} else {
								this.consentUpdated = false
								this.consentInfo = this.$t('edit.consentUpdateError')
								this.loading = false
							}
						})
						.catch(function (error) {
							this.loading = false
							window.console.warn('Failed to update user')
							window.console.warn(error)
						})
				} else {
					this.loading = false
				}
			})
		}
	},
	computed: {
		storeUser() {
			return store.state.user
		}
	}
}
</script>

<style scoped lang="scss">
.Consent_Form {
	background-color: $colorWhite;
	&__border {
		padding-top: 20px;
		&--top {
			border-top: 1px solid $colorPrimary2;
		}
		&--bottom {
			margin-top: 20px;
			border-bottom: 1px solid $colorPrimary2;
		}
	}

	&__button {
		justify-content: flex-end;
		display: flex;
		margin: 40px 0 40px 0;
	}

	&__desc {
		font-size: 12px;
		line-height: 1.3;
		font-style: italic;
		margin-top: 40px;
	}

	&__consent-text {
		text-align: left;
		margin-left: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}
.consentInfo {
	display: inline-block;
	color: $colorGreen;
	margin-top: 10px;
	&--failed {
		color: $colorRed;
	}
}

.checkbox {
	display: flex;
	position: relative;
	align-items: center;
	width: 100%;
	margin-top: 30px;
	.checkbox__box {
		flex: none;
	}
	&--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
	&__input {
		position: absolute;
		visibility: hidden;
		/*&:checked ~ .input__icon:after {
      transform: scale(1);
    }*/

		+ span > span {
			display: none;
		}
		&:checked {
			+ span {
				background-color: $colorPrimary7;
			}
			+ span > span {
				display: block;
			}
		}
	}
	&__box {
		display: inline-block;
		width: 18px;
		height: 18px;
		box-sizing: border-box;
		border: 1px solid $colorPrimary3;
		box-shadow: inset 0 1px 3px 0 rgba(148, 158, 177, 0.1);
		background-color: rgba(233, 235, 239, 0.6);
		border-radius: 3px;
		transition: all 0.3s ease;
		margin-right: 5px;
		position: relative;
		svg {
			width: 12px;
			height: 12px;
		}
		> span {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	&__title {
		align-items: center;
		display: flex;
		color: $colorPrimary;
		font-size: 16px;
		line-height: 18px;
	}
	&--lightTheme {
		.checkbox__box {
			background-color: $colorWhite;
		}
	}
}
</style>
